var cov_2azkws93fo = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Image/Magnify.tsx",
      hash = "5f25bd1c3ad651a1f901cf38687bdf97b913607d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Image/Magnify.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 16
        }
      },
      "1": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "2": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 48
        }
      },
      "3": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 52
        }
      },
      "4": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "5": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "6": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 50,
          column: 8
        }
      },
      "7": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 34
        }
      },
      "8": {
        start: {
          line: 56,
          column: 17
        },
        end: {
          line: 56,
          column: 53
        }
      },
      "9": {
        start: {
          line: 57,
          column: 18
        },
        end: {
          line: 57,
          column: 51
        }
      },
      "10": {
        start: {
          line: 58,
          column: 18
        },
        end: {
          line: 58,
          column: 34
        }
      },
      "11": {
        start: {
          line: 59,
          column: 19
        },
        end: {
          line: 59,
          column: 36
        }
      },
      "12": {
        start: {
          line: 60,
          column: 14
        },
        end: {
          line: 60,
          column: 48
        }
      },
      "13": {
        start: {
          line: 61,
          column: 14
        },
        end: {
          line: 61,
          column: 48
        }
      },
      "14": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 63
        }
      },
      "15": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 62
        }
      },
      "16": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "17": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 35
        }
      },
      "18": {
        start: {
          line: 75,
          column: 46
        },
        end: {
          line: 75,
          column: 56
        }
      },
      "19": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 37
        }
      },
      "20": {
        start: {
          line: 76,
          column: 31
        },
        end: {
          line: 76,
          column: 37
        }
      },
      "21": {
        start: {
          line: 77,
          column: 19
        },
        end: {
          line: 77,
          column: 50
        }
      },
      "22": {
        start: {
          line: 78,
          column: 33
        },
        end: {
          line: 78,
          column: 34
        }
      },
      "23": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      },
      "24": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 29
        }
      },
      "25": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 72
        }
      },
      "26": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 32
        }
      },
      "27": {
        start: {
          line: 86,
          column: 26
        },
        end: {
          line: 86,
          column: 32
        }
      },
      "28": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 35
        }
      },
      "29": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 39
        }
      },
      "30": {
        start: {
          line: 94,
          column: 41
        },
        end: {
          line: 94,
          column: 51
        }
      },
      "31": {
        start: {
          line: 95,
          column: 32
        },
        end: {
          line: 95,
          column: 42
        }
      },
      "32": {
        start: {
          line: 97,
          column: 19
        },
        end: {
          line: 97,
          column: 105
        }
      },
      "33": {
        start: {
          line: 98,
          column: 39
        },
        end: {
          line: 98,
          column: 70
        }
      },
      "34": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      "35": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 31
        }
      },
      "36": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 32
        }
      },
      "37": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 33
        }
      },
      "38": {
        start: {
          line: 105,
          column: 24
        },
        end: {
          line: 105,
          column: 66
        }
      },
      "39": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "40": {
        start: {
          line: 112,
          column: 10
        },
        end: {
          line: 112,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 46
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 41
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 17
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 66
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 34
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 36
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 81,
            column: 12
          },
          end: {
            line: 81,
            column: 13
          }
        },
        loc: {
          start: {
            line: 81,
            column: 21
          },
          end: {
            line: 84,
            column: 7
          }
        },
        line: 81
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 7
          }
        },
        loc: {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 88,
            column: 7
          }
        },
        line: 85
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 11
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 111,
            column: 13
          },
          end: {
            line: 111,
            column: 14
          }
        },
        loc: {
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 113,
            column: 9
          }
        },
        line: 111
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 40
          }
        }, {
          start: {
            line: 41,
            column: 44
          },
          end: {
            line: 41,
            column: 67
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        }],
        line: 76
      },
      "3": {
        loc: {
          start: {
            line: 77,
            column: 19
          },
          end: {
            line: 77,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 45
          },
          end: {
            line: 77,
            column: 46
          }
        }, {
          start: {
            line: 77,
            column: 49
          },
          end: {
            line: 77,
            column: 50
          }
        }],
        line: 77
      },
      "4": {
        loc: {
          start: {
            line: 83,
            column: 22
          },
          end: {
            line: 83,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 37
          },
          end: {
            line: 83,
            column: 60
          }
        }, {
          start: {
            line: 83,
            column: 63
          },
          end: {
            line: 83,
            column: 72
          }
        }],
        line: 83
      },
      "5": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 32
          }
        }, {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 32
          }
        }],
        line: 86
      },
      "6": {
        loc: {
          start: {
            line: 97,
            column: 19
          },
          end: {
            line: 97,
            column: 105
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 55
          },
          end: {
            line: 97,
            column: 92
          }
        }, {
          start: {
            line: 97,
            column: 96
          },
          end: {
            line: 97,
            column: 105
          }
        }],
        line: 97
      },
      "7": {
        loc: {
          start: {
            line: 97,
            column: 55
          },
          end: {
            line: 97,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 70
          },
          end: {
            line: 97,
            column: 80
          }
        }, {
          start: {
            line: 97,
            column: 83
          },
          end: {
            line: 97,
            column: 92
          }
        }],
        line: 97
      },
      "8": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }, {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }],
        line: 99
      },
      "9": {
        loc: {
          start: {
            line: 105,
            column: 24
          },
          end: {
            line: 105,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 105,
            column: 39
          },
          end: {
            line: 105,
            column: 54
          }
        }, {
          start: {
            line: 105,
            column: 57
          },
          end: {
            line: 105,
            column: 66
          }
        }],
        line: 105
      },
      "10": {
        loc: {
          start: {
            line: 118,
            column: 9
          },
          end: {
            line: 122,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 9
          },
          end: {
            line: 118,
            column: 16
          }
        }, {
          start: {
            line: 119,
            column: 10
          },
          end: {
            line: 121,
            column: 16
          }
        }],
        line: 118
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Image/Magnify.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import Spin from '../Spin';
import { imageClass } from './styles';
import { PureComponent } from '../component';

var Magnify =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Magnify, _PureComponent);

  var _super = _createSuper2(Magnify);

  function Magnify(props) {
    var _this;

    _classCallCheck(this, Magnify);

    cov_2azkws93fo.f[0]++;
    cov_2azkws93fo.s[0]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_2azkws93fo.s[1]++;
    _this.state = {
      loading: true,
      status: 0,
      style: {
        maxHeight: props.maxHeight,
        maxWidth: props.maxWidth
      }
    };
    cov_2azkws93fo.s[2]++;
    _this.handleMove = _this.handleMove.bind(_assertThisInitialized(_this));
    cov_2azkws93fo.s[3]++;
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    cov_2azkws93fo.s[4]++;
    _this.handleLoaded = _this.handleLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Magnify, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_2azkws93fo.f[1]++;
      cov_2azkws93fo.s[5]++;

      if ((cov_2azkws93fo.b[1][0]++, prevProps.src !== this.props.src) && (cov_2azkws93fo.b[1][1]++, this.state.status === 1)) {
        cov_2azkws93fo.b[0][0]++;
        cov_2azkws93fo.s[6]++;
        // eslint-disable-next-line
        this.setState({
          loading: true,
          status: 0,
          style: {
            maxHeight: this.props.maxHeight,
            maxWidth: this.props.maxWidth
          }
        });
        cov_2azkws93fo.s[7]++;
        this.props.lockScroll(false);
      } else {
        cov_2azkws93fo.b[0][1]++;
      }
    }
  }, {
    key: "move",
    value: function move(clientX, clientY) {
      cov_2azkws93fo.f[2]++;
      var rect = (cov_2azkws93fo.s[8]++, this.element.getBoundingClientRect());
      var image = (cov_2azkws93fo.s[9]++, this.element.querySelector('img'));
      var width = (cov_2azkws93fo.s[10]++, rect.width - 100);
      var height = (cov_2azkws93fo.s[11]++, rect.height - 100);
      var x = (cov_2azkws93fo.s[12]++, (clientX - rect.left - 50) / width);
      var y = (cov_2azkws93fo.s[13]++, (clientY - rect.top - 50) / height);
      cov_2azkws93fo.s[14]++;
      this.element.scrollTop = (image.offsetHeight - height) * y;
      cov_2azkws93fo.s[15]++;
      this.element.scrollLeft = (image.offsetWidth - width) * x;
    }
  }, {
    key: "handleLoaded",
    value: function handleLoaded() {
      cov_2azkws93fo.f[3]++;
      cov_2azkws93fo.s[16]++;
      this.setState({
        loading: false
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(e) {
      cov_2azkws93fo.f[4]++;
      cov_2azkws93fo.s[17]++;
      this.move(e.clientX, e.clientY);
    }
  }, {
    key: "handleResize",
    value: function handleResize(e) {
      var _this2 = this;

      cov_2azkws93fo.f[5]++;

      var _ref = (cov_2azkws93fo.s[18]++, this.props),
          maxHeight = _ref.maxHeight,
          maxWidth = _ref.maxWidth,
          position = _ref.position;

      cov_2azkws93fo.s[19]++;

      if (position !== 'center') {
        cov_2azkws93fo.b[2][0]++;
        cov_2azkws93fo.s[20]++;
        return;
      } else {
        cov_2azkws93fo.b[2][1]++;
      }

      var status = (cov_2azkws93fo.s[21]++, this.state.status === 1 ? (cov_2azkws93fo.b[3][0]++, 0) : (cov_2azkws93fo.b[3][1]++, 1));

      var _ref2 = (cov_2azkws93fo.s[22]++, e),
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      cov_2azkws93fo.s[23]++;
      this.setState(immer(function (state) {
        cov_2azkws93fo.f[6]++;
        cov_2azkws93fo.s[24]++;
        state.status = status;
        cov_2azkws93fo.s[25]++;
        state.style = status === 0 ? (cov_2azkws93fo.b[4][0]++, {
          maxHeight: maxHeight,
          maxWidth: maxWidth
        }) : (cov_2azkws93fo.b[4][1]++, undefined);
      }), function () {
        cov_2azkws93fo.f[7]++;
        cov_2azkws93fo.s[26]++;

        if (status === 0) {
          cov_2azkws93fo.b[5][0]++;
          cov_2azkws93fo.s[27]++;
          return;
        } else {
          cov_2azkws93fo.b[5][1]++;
        }

        cov_2azkws93fo.s[28]++;

        _this2.move(clientX, clientY);
      });
      cov_2azkws93fo.s[29]++;
      this.props.lockScroll(status === 1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      cov_2azkws93fo.f[8]++;

      var _ref3 = (cov_2azkws93fo.s[30]++, this.props),
          maxHeight = _ref3.maxHeight,
          maxWidth = _ref3.maxWidth,
          src = _ref3.src;

      var _ref4 = (cov_2azkws93fo.s[31]++, this.state),
          status = _ref4.status,
          loading = _ref4.loading; // eslint-disable-next-line


      var cursor = (cov_2azkws93fo.s[32]++, this.props.position === 'center' ? (cov_2azkws93fo.b[6][0]++, status === 1 ? (cov_2azkws93fo.b[7][0]++, 'zoom-out') : (cov_2azkws93fo.b[7][1]++, 'zoom-in')) : (cov_2azkws93fo.b[6][1]++, 'pointer'));
      var style = (cov_2azkws93fo.s[33]++, {
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        cursor: cursor
      });
      cov_2azkws93fo.s[34]++;

      if (status === 1) {
        cov_2azkws93fo.b[8][0]++;
        cov_2azkws93fo.s[35]++;
        style.overflow = 'scroll';
        cov_2azkws93fo.s[36]++;
        style.borderRightWidth = 0;
        cov_2azkws93fo.s[37]++;
        style.borderBottomWidth = 0;
      } else {
        cov_2azkws93fo.b[8][1]++;
      }

      var onMouseMove = (cov_2azkws93fo.s[38]++, status === 1 ? (cov_2azkws93fo.b[9][0]++, this.handleMove) : (cov_2azkws93fo.b[9][1]++, undefined));
      cov_2azkws93fo.s[39]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleResize,
          onMouseMove: onMouseMove,
          ref: function ref(el) {
            cov_2azkws93fo.f[9]++;
            cov_2azkws93fo.s[40]++;
            _this3.element = el;
          },
          style: style,
          className: imageClass('magnify'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("img", {
          onLoad: this.handleLoaded,
          src: src,
          alt: "",
          style: this.state.style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 117,
            columnNumber: 9
          }
        }), (cov_2azkws93fo.b[10][0]++, loading) && (cov_2azkws93fo.b[10][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: imageClass('magnify-loading'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 30,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120,
            columnNumber: 13
          }
        }))))
      );
    }
  }]);

  return Magnify;
}(PureComponent);

export default Magnify;